import React from 'react';
import { FiX, FiUser, FiClock } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';
import { formatDate } from '../utils/dateUtils';

const MessageDetailPanel = ({ selectedMessage, setSelectedMessage }) => {
    return (
        <AnimatePresence>
            {selectedMessage && (
                <>
                    <motion.div 
                        className="overlay"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 0.5 }}
                        exit={{ opacity: 0 }}
                        onClick={() => setSelectedMessage(null)}
                    />
                    <motion.div 
                        className="message-detail-panel"
                        initial={{ x: "100%" }}
                        animate={{ x: 0 }}
                        exit={{ x: "100%" }}
                        transition={{ type: "spring", damping: 25, stiffness: 200 }}
                    >
                        <div className="detail-panel-header">
                            <div className="header-content">
                                <h2>{selectedMessage.subject || 'No Subject'}</h2>
                                <div className="message-meta">
                                    <div className="meta-item">
                                        <FiUser />
                                        <span>{selectedMessage.sender}</span>
                                    </div>
                                    <div className="meta-item">
                                        <FiClock />
                                        <span>{formatDate(selectedMessage.receivedAt)}</span>
                                    </div>
                                </div>
                            </div>
                            <button 
                                className="close-button"
                                onClick={() => setSelectedMessage(null)}
                                aria-label="Close message details"
                            >
                                <FiX />
                            </button>
                        </div>
                        <div className="detail-panel-content">
                            <div className="message-content">
                                {console.log('Content:', selectedMessage.content)}
                                {console.log('Is HTML?:', selectedMessage.content.includes('<'))}
                                {selectedMessage.content.includes('<') ? (
                                    <div 
                                        className="html-content"
                                        dangerouslySetInnerHTML={{ 
                                            __html: selectedMessage.content.trim() 
                                        }} 
                                    />
                                ) : (
                                    selectedMessage.content.split('\n').map((line, index) => (
                                        <p key={index}>{line}</p>
                                    ))
                                )}
                            </div>
                        </div>
                    </motion.div>
                </>
            )}
        </AnimatePresence>
    );
};

export default MessageDetailPanel; 